import styles from './home-public.module.scss';

export type AuthIconName = 'person' | 'lock';

type AuthIconProps = {
  name: AuthIconName;
};

const icons: Record<AuthIconName, JSX.Element> = {
  person: (
    <g fill="currentColor">
      <path d="M18 17.7604C22.5499 17.7604 26.25 14.3686 26.25 10.1979V8.9375C26.25 4.76678 22.5499 1.375 18 1.375C13.4501 1.375 9.75 4.76678 9.75 8.9375V10.1979C9.75 14.3686 13.4501 17.7604 18 17.7604Z" />
      <path d="M28.0678 21.5179C21.5998 19.8756 14.4016 19.8756 7.93225 21.5179C4.95537 22.2741 2.875 24.7735 2.875 27.5981V31.6252H33.125V27.5981C33.125 24.7735 31.0446 22.2741 28.0678 21.5179Z" />
    </g>
  ),
  lock: (
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      transform="translate(6 0)"
    >
      <path d="M20 15H4C2.34315 15 1 16.3431 1 18V32C1 33.6569 2.34315 35 4 35H20C21.6569 35 23 33.6569 23 32V18C23 16.3431 21.6569 15 20 15Z" />
      <path d="M5 15V8C5 6.14348 5.7375 4.36302 7.05025 3.05026C8.36301 1.73751 10.1435 1 12 1C13.8565 1 15.637 1.73751 16.9497 3.05026C18.2625 4.36302 19 6.14348 19 8V15" />
    </g>
  ),
};

const AuthIcon: React.FC<AuthIconProps> = ({ name }) => (
  <svg
    aria-hidden="true"
    className={styles.icon}
    focusable="false"
    viewBox="0 0 36 36"
  >
    {icons[name]}
  </svg>
);

export default AuthIcon;
